import React from 'react';
import bizIcon from 'assets/svg/biz-loading.svg';

const Loading: React.FC = (): JSX.Element => {
    return (
        <div className="mx-auto mt-5" style={{ textAlign: 'center' }}>
            <img src={bizIcon} />
        </div>
    );
};

export default Loading;
